import { round, floor, ceil } from 'lodash'

export default {
  /**
   * Calculate a / b as a percentage. Pass a null precision to get the unrounded value, so callers that round again
   * for display don't double-round (e.g. 55.046 -> 55.05 -> 55.1 instead of 55.0).
   */
  percentage (a, b, precision = 2, mode = 'round') {
    a = Number(a)
    b = Number(b)
    if (b == null || b === 0 || Number.isNaN(a) || Number.isNaN(b)) {
      return 0
    }
    const value = a / b * 100
    if (precision === null) {
      return value
    }
    switch (mode) {
      case 'floor':
        return floor(value, precision)
      case 'ceil':
        return ceil(value, precision)
      case 'round':
      default:
        return round(value, precision)
    }
  }
}
